var map = {
	"./360_Tour.png": "./src/assets/images/360_Tour.png",
	"./404page.png": "./src/assets/images/404page.png",
	"./Adam.jpg": "./src/assets/images/Adam.jpg",
	"./Agent2.jpg": "./src/assets/images/Agent2.jpg",
	"./Agent3.jpg": "./src/assets/images/Agent3.jpg",
	"./Agent4.jpg": "./src/assets/images/Agent4.jpg",
	"./Agent5.jpg": "./src/assets/images/Agent5.jpg",
	"./Avatar.png": "./src/assets/images/Avatar.png",
	"./Bg3.png": "./src/assets/images/Bg3.png",
	"./Bitmap.png": "./src/assets/images/Bitmap.png",
	"./Bitmap@2x.png": "./src/assets/images/Bitmap@2x.png",
	"./Bitmap@3x.png": "./src/assets/images/Bitmap@3x.png",
	"./Careers.jpg": "./src/assets/images/Careers.jpg",
	"./Check File icon 2.svg": "./src/assets/images/Check File icon 2.svg",
	"./Group 3.png": "./src/assets/images/Group 3.png",
	"./Group 3@2x.png": "./src/assets/images/Group 3@2x.png",
	"./Group 3@3x.png": "./src/assets/images/Group 3@3x.png",
	"./HalifaxBannerTab.jpeg": "./src/assets/images/HalifaxBannerTab.jpeg",
	"./Hestia_Logo.png": "./src/assets/images/Hestia_Logo.png",
	"./HowItWorkImage1.jpg": "./src/assets/images/HowItWorkImage1.jpg",
	"./HowItWorkImage2.jpeg": "./src/assets/images/HowItWorkImage2.jpeg",
	"./HowItWorkImage3.jpg": "./src/assets/images/HowItWorkImage3.jpg",
	"./HowItWorkImage4.jpeg": "./src/assets/images/HowItWorkImage4.jpeg",
	"./HowItWorkImage5.jpg": "./src/assets/images/HowItWorkImage5.jpg",
	"./IG_square_TEMPLATE4.png": "./src/assets/images/IG_square_TEMPLATE4.png",
	"./Image.png": "./src/assets/images/Image.png",
	"./Image@2x.png": "./src/assets/images/Image@2x.png",
	"./Introducingtlyfe.png": "./src/assets/images/Introducingtlyfe.png",
	"./Investors.jpg": "./src/assets/images/Investors.jpg",
	"./Jhon.png": "./src/assets/images/Jhon.png",
	"./Just_giving_logo.png": "./src/assets/images/Just_giving_logo.png",
	"./LoaderLogo.gif": "./src/assets/images/LoaderLogo.gif",
	"./MLS.jpg": "./src/assets/images/MLS.jpg",
	"./Next_Generation_Portal.jpg": "./src/assets/images/Next_Generation_Portal.jpg",
	"./Openflo.png": "./src/assets/images/Openflo.png",
	"./Openflo@2x.png": "./src/assets/images/Openflo@2x.png",
	"./Openflo@3x.png": "./src/assets/images/Openflo@3x.png",
	"./Oval.png": "./src/assets/images/Oval.png",
	"./Oval@2x.png": "./src/assets/images/Oval@2x.png",
	"./OvalBig.png": "./src/assets/images/OvalBig.png",
	"./Partnerships.jpg": "./src/assets/images/Partnerships.jpg",
	"./Progress.svg": "./src/assets/images/Progress.svg",
	"./Rail.png": "./src/assets/images/Rail.png",
	"./Rectangle.png": "./src/assets/images/Rectangle.png",
	"./SHI.png": "./src/assets/images/SHI.png",
	"./Schools.png": "./src/assets/images/Schools.png",
	"./Shahad.jpg": "./src/assets/images/Shahad.jpg",
	"./Shines_logo.png": "./src/assets/images/Shines_logo.png",
	"./TenancyDeposit Scheme_NI.png": "./src/assets/images/TenancyDeposit Scheme_NI.png",
	"./TenantBuyer2.jpg": "./src/assets/images/TenantBuyer2.jpg",
	"./TenantBuyer3.jpg": "./src/assets/images/TenantBuyer3.jpg",
	"./TenantBuyer4.jpg": "./src/assets/images/TenantBuyer4.jpg",
	"./Tram.png": "./src/assets/images/Tram.png",
	"./Tube.png": "./src/assets/images/Tube.png",
	"./Vector1.png": "./src/assets/images/Vector1.png",
	"./Vector2.png": "./src/assets/images/Vector2.png",
	"./Vector3.png": "./src/assets/images/Vector3.png",
	"./Verfied.png": "./src/assets/images/Verfied.png",
	"./X.png": "./src/assets/images/X.png",
	"./X@2x.png": "./src/assets/images/X@2x.png",
	"./X@3x.png": "./src/assets/images/X@3x.png",
	"./aboutus/checkbox.png": "./src/assets/images/aboutus/checkbox.png",
	"./aboutus/circle.png": "./src/assets/images/aboutus/circle.png",
	"./aboutus/contactus.png": "./src/assets/images/aboutus/contactus.png",
	"./aboutus/desktop.png": "./src/assets/images/aboutus/desktop.png",
	"./aboutus/mls.png": "./src/assets/images/aboutus/mls.png",
	"./aboutus/openbrixlogo.png": "./src/assets/images/aboutus/openbrixlogo.png",
	"./aboutus/phone.png": "./src/assets/images/aboutus/phone.png",
	"./aboutus/tlyfeDesktop.png": "./src/assets/images/aboutus/tlyfeDesktop.png",
	"./aboutus/tv.png": "./src/assets/images/aboutus/tv.png",
	"./anyvan.png": "./src/assets/images/anyvan.png",
	"./auto.png": "./src/assets/images/auto.png",
	"./b1.png": "./src/assets/images/b1.png",
	"./b2.png": "./src/assets/images/b2.png",
	"./b3.png": "./src/assets/images/b3.png",
	"./backIcon.png": "./src/assets/images/backIcon.png",
	"./backIcon@2x.png": "./src/assets/images/backIcon@2x.png",
	"./backIcon@3x.png": "./src/assets/images/backIcon@3x.png",
	"./beachhouse.png": "./src/assets/images/beachhouse.png",
	"./bg1.png": "./src/assets/images/bg1.png",
	"./bg2.png": "./src/assets/images/bg2.png",
	"./bunglow.png": "./src/assets/images/bunglow.png",
	"./caveat-down.png": "./src/assets/images/caveat-down.png",
	"./caveat-down@2x.png": "./src/assets/images/caveat-down@2x.png",
	"./caveat-down@3x.png": "./src/assets/images/caveat-down@3x.png",
	"./charity.png": "./src/assets/images/charity.png",
	"./chileimage1.png": "./src/assets/images/chileimage1.png",
	"./clbanner.png": "./src/assets/images/clbanner.png",
	"./clickhere.png": "./src/assets/images/clickhere.png",
	"./clickhereMobile.png": "./src/assets/images/clickhereMobile.png",
	"./complete.png": "./src/assets/images/complete.png",
	"./courtyard.png": "./src/assets/images/courtyard.png",
	"./creditScore.png": "./src/assets/images/creditScore.png",
	"./creditladder.png": "./src/assets/images/creditladder.png",
	"./cross.png": "./src/assets/images/cross.png",
	"./ctax.png": "./src/assets/images/ctax.png",
	"./deposit.png": "./src/assets/images/deposit.png",
	"./detached.png": "./src/assets/images/detached.png",
	"./digitalid.png": "./src/assets/images/digitalid.png",
	"./doc_seen.png": "./src/assets/images/doc_seen.png",
	"./doc_unseen.png": "./src/assets/images/doc_unseen.png",
	"./document.png": "./src/assets/images/document.png",
	"./download_cloud_icon.png": "./src/assets/images/download_cloud_icon.png",
	"./drawerMenu.png": "./src/assets/images/drawerMenu.png",
	"./drawerMenu@2x.png": "./src/assets/images/drawerMenu@2x.png",
	"./drawerMenu@3x.png": "./src/assets/images/drawerMenu@3x.png",
	"./drawerWhite.png": "./src/assets/images/drawerWhite.png",
	"./electricity.png": "./src/assets/images/electricity.png",
	"./empower.png": "./src/assets/images/empower.png",
	"./expand.png": "./src/assets/images/expand.png",
	"./facebook.svg": "./src/assets/images/facebook.svg",
	"./facebookBig.png": "./src/assets/images/facebookBig.png",
	"./failed.png": "./src/assets/images/failed.png",
	"./farm.png": "./src/assets/images/farm.png",
	"./favicon.png": "./src/assets/images/favicon.png",
	"./fccparagon.png": "./src/assets/images/fccparagon.png",
	"./flats.png": "./src/assets/images/flats.png",
	"./flatsO.png": "./src/assets/images/flatsO.png",
	"./gas.png": "./src/assets/images/gas.png",
	"./global_logo.png": "./src/assets/images/global_logo.png",
	"./gov.png": "./src/assets/images/gov.png",
	"./halifax.png": "./src/assets/images/halifax.png",
	"./halifaxWebBanner.jpeg": "./src/assets/images/halifaxWebBanner.jpeg",
	"./halifaxlogo.jpeg": "./src/assets/images/halifaxlogo.jpeg",
	"./halifaxlogo.png": "./src/assets/images/halifaxlogo.png",
	"./homeImage.png": "./src/assets/images/homeImage.png",
	"./homeImage@2x.png": "./src/assets/images/homeImage@2x.png",
	"./homeImage@3x.png": "./src/assets/images/homeImage@3x.png",
	"./homeImageMobile.png": "./src/assets/images/homeImageMobile.png",
	"./homeImageMobile3x.png": "./src/assets/images/homeImageMobile3x.png",
	"./homeImageMobile@2x.png": "./src/assets/images/homeImageMobile@2x.png",
	"./homebox.svg": "./src/assets/images/homebox.svg",
	"./homesetup-media.jpeg": "./src/assets/images/homesetup-media.jpeg",
	"./hometelecom.png": "./src/assets/images/hometelecom.png",
	"./idBackground.png": "./src/assets/images/idBackground.png",
	"./idRef.png": "./src/assets/images/idRef.png",
	"./improve.png": "./src/assets/images/improve.png",
	"./independent.png": "./src/assets/images/independent.png",
	"./infohub/cards.png": "./src/assets/images/infohub/cards.png",
	"./infohub/comment.png": "./src/assets/images/infohub/comment.png",
	"./infohub/copy.png": "./src/assets/images/infohub/copy.png",
	"./infohub/fb.png": "./src/assets/images/infohub/fb.png",
	"./infohub/like.png": "./src/assets/images/infohub/like.png",
	"./infohub/linkdin.png": "./src/assets/images/infohub/linkdin.png",
	"./infohub/reddit.png": "./src/assets/images/infohub/reddit.png",
	"./infohub/verified.png": "./src/assets/images/infohub/verified.png",
	"./infohub/watch.png": "./src/assets/images/infohub/watch.png",
	"./infohub/x.png": "./src/assets/images/infohub/x.png",
	"./inprogress.png": "./src/assets/images/inprogress.png",
	"./instagram.svg": "./src/assets/images/instagram.svg",
	"./instagramBig.png": "./src/assets/images/instagramBig.png",
	"./interactive.png": "./src/assets/images/interactive.png",
	"./intro.png": "./src/assets/images/intro.png",
	"./introScreenIcon.png": "./src/assets/images/introScreenIcon.png",
	"./introScreenIcon@2x.png": "./src/assets/images/introScreenIcon@2x.png",
	"./introScreenIcon@3x.png": "./src/assets/images/introScreenIcon@3x.png",
	"./learning.png": "./src/assets/images/learning.png",
	"./lifetime.png": "./src/assets/images/lifetime.png",
	"./linkedIn.png": "./src/assets/images/linkedIn.png",
	"./linkedInBig.png": "./src/assets/images/linkedInBig.png",
	"./linkedInNew.png": "./src/assets/images/linkedInNew.png",
	"./linkedin.svg": "./src/assets/images/linkedin.svg",
	"./logo.svg": "./src/assets/images/logo.svg",
	"./logoText/Audience.png": "./src/assets/images/logoText/Audience.png",
	"./logoText/Audience@2x.png": "./src/assets/images/logoText/Audience@2x.png",
	"./logoText/Audience@3x.png": "./src/assets/images/logoText/Audience@3x.png",
	"./logoText/Collab.png": "./src/assets/images/logoText/Collab.png",
	"./logoText/Collab@2x.png": "./src/assets/images/logoText/Collab@2x.png",
	"./logoText/Collab@3x.png": "./src/assets/images/logoText/Collab@3x.png",
	"./logoText/Extra.png": "./src/assets/images/logoText/Extra.png",
	"./logoText/Extra@2x.png": "./src/assets/images/logoText/Extra@2x.png",
	"./logoText/Extra@3x.png": "./src/assets/images/logoText/Extra@3x.png",
	"./logoText/efficient.png": "./src/assets/images/logoText/efficient.png",
	"./logoText/efficient@2x.png": "./src/assets/images/logoText/efficient@2x.png",
	"./logoText/efficient@3x.png": "./src/assets/images/logoText/efficient@3x.png",
	"./logoText/end2end.png": "./src/assets/images/logoText/end2end.png",
	"./logoText/end2end@2x.png": "./src/assets/images/logoText/end2end@2x.png",
	"./logoText/end2end@3x.png": "./src/assets/images/logoText/end2end@3x.png",
	"./logoText/mls.png": "./src/assets/images/logoText/mls.png",
	"./logoText/mls@2x.png": "./src/assets/images/logoText/mls@2x.png",
	"./logoText/mls@3x.png": "./src/assets/images/logoText/mls@3x.png",
	"./logoText/mobileViewBack.png": "./src/assets/images/logoText/mobileViewBack.png",
	"./logoText/mobileViewBack@2x.png": "./src/assets/images/logoText/mobileViewBack@2x.png",
	"./logoText/mobileViewBack@3x.png": "./src/assets/images/logoText/mobileViewBack@3x.png",
	"./logoText/movein.png": "./src/assets/images/logoText/movein.png",
	"./logoText/movein@2x.png": "./src/assets/images/logoText/movein@2x.png",
	"./logoText/movein@3x.png": "./src/assets/images/logoText/movein@3x.png",
	"./logoText/openbrix.png": "./src/assets/images/logoText/openbrix.png",
	"./logoText/openbrix@2x.png": "./src/assets/images/logoText/openbrix@2x.png",
	"./logoText/openbrix@3x.png": "./src/assets/images/logoText/openbrix@3x.png",
	"./logoText/openflow.png": "./src/assets/images/logoText/openflow.png",
	"./logoText/openflow@2x.png": "./src/assets/images/logoText/openflow@2x.png",
	"./logoText/openflow@3x.png": "./src/assets/images/logoText/openflow@3x.png",
	"./logoText/openflowFirst.png": "./src/assets/images/logoText/openflowFirst.png",
	"./logoText/openflowFirst@2x.png": "./src/assets/images/logoText/openflowFirst@2x.png",
	"./logoText/openflowFirst@3x.png": "./src/assets/images/logoText/openflowFirst@3x.png",
	"./logoText/search.png": "./src/assets/images/logoText/search.png",
	"./logoText/search@2x.png": "./src/assets/images/logoText/search@2x.png",
	"./logoText/search@3x.png": "./src/assets/images/logoText/search@3x.png",
	"./logoText/tlyfe.png": "./src/assets/images/logoText/tlyfe.png",
	"./logoText/tlyfe@2x.png": "./src/assets/images/logoText/tlyfe@2x.png",
	"./logoText/tlyfe@3x.png": "./src/assets/images/logoText/tlyfe@3x.png",
	"./mainBg.png": "./src/assets/images/mainBg.png",
	"./mainBgMobile.png": "./src/assets/images/mainBgMobile.png",
	"./mainBgTablet.png": "./src/assets/images/mainBgTablet.png",
	"./maintainence_alert.png": "./src/assets/images/maintainence_alert.png",
	"./maintenance.png": "./src/assets/images/maintenance.png",
	"./makeexport.png": "./src/assets/images/makeexport.png",
	"./marketplace.png": "./src/assets/images/marketplace.png",
	"./mediaDummy.png": "./src/assets/images/mediaDummy.png",
	"./multilisting.png": "./src/assets/images/multilisting.png",
	"./myaccount.png": "./src/assets/images/myaccount.png",
	"./notification.png": "./src/assets/images/notification.png",
	"./notstarted.png": "./src/assets/images/notstarted.png",
	"./obxLogo.png": "./src/assets/images/obxLogo.png",
	"./obxLogo3x.png": "./src/assets/images/obxLogo3x.png",
	"./obxLogo@2x.png": "./src/assets/images/obxLogo@2x.png",
	"./obxLogoBig.png": "./src/assets/images/obxLogoBig.png",
	"./obxWhite.png": "./src/assets/images/obxWhite.png",
	"./obxWhite@2x.png": "./src/assets/images/obxWhite@2x.png",
	"./obxWhite@3x.png": "./src/assets/images/obxWhite@3x.png",
	"./obx_black.png": "./src/assets/images/obx_black.png",
	"./obx_smallLogo.jpeg": "./src/assets/images/obx_smallLogo.jpeg",
	"./openbrix-favicon.jpg": "./src/assets/images/openbrix-favicon.jpg",
	"./openflow/agreement.png": "./src/assets/images/openflow/agreement.png",
	"./openflow/broadband.png": "./src/assets/images/openflow/broadband.png",
	"./openflow/bulb.png": "./src/assets/images/openflow/bulb.png",
	"./openflow/council_tax.png": "./src/assets/images/openflow/council_tax.png",
	"./openflow/gas.png": "./src/assets/images/openflow/gas.png",
	"./openflow/home.png": "./src/assets/images/openflow/home.png",
	"./openflow/homelogo.png": "./src/assets/images/openflow/homelogo.png",
	"./openflow/tv.png": "./src/assets/images/openflow/tv.png",
	"./openflow/water.png": "./src/assets/images/openflow/water.png",
	"./other.png": "./src/assets/images/other.png",
	"./partners.png": "./src/assets/images/partners.png",
	"./pda1.png": "./src/assets/images/pda1.png",
	"./pda2.png": "./src/assets/images/pda2.png",
	"./pda3.png": "./src/assets/images/pda3.png",
	"./pda4.png": "./src/assets/images/pda4.png",
	"./preBackground.png": "./src/assets/images/preBackground.png",
	"./preRefrence.png": "./src/assets/images/preRefrence.png",
	"./prequal.png": "./src/assets/images/prequal.png",
	"./primary.png": "./src/assets/images/primary.png",
	"./propertyAlert.png": "./src/assets/images/propertyAlert.png",
	"./property_alert.png": "./src/assets/images/property_alert.png",
	"./reNewProcess.svg": "./src/assets/images/reNewProcess.svg",
	"./referfriend.png": "./src/assets/images/referfriend.png",
	"./renovation.png": "./src/assets/images/renovation.png",
	"./rent.png": "./src/assets/images/rent.png",
	"./rentBackground.png": "./src/assets/images/rentBackground.png",
	"./rentLedgerAlert.png": "./src/assets/images/rentLedgerAlert.png",
	"./rentalpassport.png": "./src/assets/images/rentalpassport.png",
	"./rentalpassword.png": "./src/assets/images/rentalpassword.png",
	"./rentsmarter.png": "./src/assets/images/rentsmarter.png",
	"./restart.svg": "./src/assets/images/restart.svg",
	"./rewards_basic.png": "./src/assets/images/rewards_basic.png",
	"./rewards_premium.png": "./src/assets/images/rewards_premium.png",
	"./rewards_premium_exp.png": "./src/assets/images/rewards_premium_exp.png",
	"./rewards_premium_suscribed.png": "./src/assets/images/rewards_premium_suscribed.png",
	"./right.png": "./src/assets/images/right.png",
	"./saveProperty.png": "./src/assets/images/saveProperty.png",
	"./school_marker.png": "./src/assets/images/school_marker.png",
	"./secondary.png": "./src/assets/images/secondary.png",
	"./semi-detached.png": "./src/assets/images/semi-detached.png",
	"./semi-detachedNew.png": "./src/assets/images/semi-detachedNew.png",
	"./share.png": "./src/assets/images/share.png",
	"./sky.png": "./src/assets/images/sky.png",
	"./storage.png": "./src/assets/images/storage.png",
	"./store/app.png": "./src/assets/images/store/app.png",
	"./store/play.png": "./src/assets/images/store/play.png",
	"./strategic.png": "./src/assets/images/strategic.png",
	"./strategicMobile.png": "./src/assets/images/strategicMobile.png",
	"./stripe.png": "./src/assets/images/stripe.png",
	"./supplierAlert.png": "./src/assets/images/supplierAlert.png",
	"./tds-account.png": "./src/assets/images/tds-account.png",
	"./tds-profile.png": "./src/assets/images/tds-profile.png",
	"./tds.png": "./src/assets/images/tds.png",
	"./tds_logo.png": "./src/assets/images/tds_logo.png",
	"./tds_scotland.png": "./src/assets/images/tds_scotland.png",
	"./tdsengland.png": "./src/assets/images/tdsengland.png",
	"./tdslogoWhite.png": "./src/assets/images/tdslogoWhite.png",
	"./tenantInsurance.png": "./src/assets/images/tenantInsurance.png",
	"./tenantInsuranceHouse.png": "./src/assets/images/tenantInsuranceHouse.png",
	"./tenantloan.png": "./src/assets/images/tenantloan.png",
	"./tenenatInfoBack.png": "./src/assets/images/tenenatInfoBack.png",
	"./terraced.png": "./src/assets/images/terraced.png",
	"./thirdparty.png": "./src/assets/images/thirdparty.png",
	"./tlyfBanner.png": "./src/assets/images/tlyfBanner.png",
	"./tlyfe-black-logo.png": "./src/assets/images/tlyfe-black-logo.png",
	"./tlyfe.png": "./src/assets/images/tlyfe.png",
	"./tlyfe/tlyfe.png": "./src/assets/images/tlyfe/tlyfe.png",
	"./tlyfe/tlyfe@2x.png": "./src/assets/images/tlyfe/tlyfe@2x.png",
	"./tlyfe/tlyfe@3x.png": "./src/assets/images/tlyfe/tlyfe@3x.png",
	"./tlyfeBig.png": "./src/assets/images/tlyfeBig.png",
	"./tlyfeImageText.png": "./src/assets/images/tlyfeImageText.png",
	"./tlyfeImageText1.png": "./src/assets/images/tlyfeImageText1.png",
	"./tlyfeImageText2.png": "./src/assets/images/tlyfeImageText2.png",
	"./tlyfeImageText3.png": "./src/assets/images/tlyfeImageText3.png",
	"./tlyfeLogo.png": "./src/assets/images/tlyfeLogo.png",
	"./tlyfeLogo1.png": "./src/assets/images/tlyfeLogo1.png",
	"./tlyfeWhite.png": "./src/assets/images/tlyfeWhite.png",
	"./tlyfeimages/aff.png": "./src/assets/images/tlyfeimages/aff.png",
	"./tlyfeimages/afford.png": "./src/assets/images/tlyfeimages/afford.png",
	"./tlyfeimages/credit.png": "./src/assets/images/tlyfeimages/credit.png",
	"./tlyfeimages/fccMobile.png": "./src/assets/images/tlyfeimages/fccMobile.png",
	"./tlyfeimages/fccWeb.png": "./src/assets/images/tlyfeimages/fccWeb.png",
	"./tlyfeimages/hestia.png": "./src/assets/images/tlyfeimages/hestia.png",
	"./tlyfeimages/id&verification.png": "./src/assets/images/tlyfeimages/id&verification.png",
	"./tlyfeimages/idandflo.png": "./src/assets/images/tlyfeimages/idandflo.png",
	"./tlyfeimages/idverification.png": "./src/assets/images/tlyfeimages/idverification.png",
	"./tlyfeimages/preref.png": "./src/assets/images/tlyfeimages/preref.png",
	"./tlyfeimages/righttorent.png": "./src/assets/images/tlyfeimages/righttorent.png",
	"./tlyfeimages/rtr.png": "./src/assets/images/tlyfeimages/rtr.png",
	"./tlyfeimages/tds.png": "./src/assets/images/tlyfeimages/tds.png",
	"./tlyfheader.png": "./src/assets/images/tlyfheader.png",
	"./tlyfwhite.png": "./src/assets/images/tlyfwhite.png",
	"./townhouse.png": "./src/assets/images/townhouse.png",
	"./transport.png": "./src/assets/images/transport.png",
	"./travel_marker.png": "./src/assets/images/travel_marker.png",
	"./twitter.svg": "./src/assets/images/twitter.svg",
	"./twitterBig.png": "./src/assets/images/twitterBig.png",
	"./uploadsuccess.png": "./src/assets/images/uploadsuccess.png",
	"./user.png": "./src/assets/images/user.png",
	"./water.png": "./src/assets/images/water.png",
	"./webBg.png": "./src/assets/images/webBg.png",
	"./workflowtool.png": "./src/assets/images/workflowtool.png",
	"./yoti.svg": "./src/assets/images/yoti.svg",
	"./zopa_big_logo.png": "./src/assets/images/zopa_big_logo.png",
	"./zopa_green_logo.png": "./src/assets/images/zopa_green_logo.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";